export default {
  "content": "<circle cx=\"128\" cy=\"256\" r=\"48\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"384\" cy=\"112\" r=\"48\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"384\" cy=\"400\" r=\"48\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M169.83 279.53l172.34 96.94m0-240.94l-172.34 96.94\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};